import React, { useEffect, useState } from "react";
import './LogsPage.css';

function LogsPage() {
  const [logs, setLogs] = useState([]);
  const [selectedLog, setSelectedLog] = useState(null);

  useEffect(() => {
    fetch("/logs")
      .then(res => res.json())
      .then(data => setLogs(data))
      .catch(err => console.error(err));
  }, []);

  const selectLog = (log) => {
    if (selectedLog && selectedLog._id === log._id) {
      setSelectedLog(null);
    } else {
      fetch(`/logs/${log._id}`)
        .then(res => res.json())
        .then(data => setSelectedLog(data))
        .catch(err => console.error(err));
    }
  };

  const handleDelete = (logId) => {
    if (!window.confirm("Are you sure you want to delete this log?")) {
      return;
    }
    fetch(`/logs/${logId}`, { method: "DELETE" })
      .then(res => {
        if (!res.ok) {
          throw new Error("Failed to delete log");
        }
        // Удаление из локального состояния после успешного удаления
        setLogs(prevLogs => prevLogs.filter(log => log._id !== logId));
        // Если удаленный лог был выбран, сбросить selectedLog
        if (selectedLog && selectedLog._id === logId) {
          setSelectedLog(null);
        }
      })
      .catch(err => console.error(err));
  };

  return (
    <div className="logs-container">
      <h2>Logs</h2>
      <ul className="logs-list">
        {logs.map(log => (
          <li key={log._id}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <button onClick={() => selectLog(log)} style={{ flexGrow: 1, marginRight: "10px" }}>
                {log.subject} - {new Date(log.date).toLocaleString()}
              </button>
              <button 
                onClick={() => handleDelete(log._id)} 
                style={{ backgroundColor: "red", color: "white", border: "none", borderRadius: "4px", padding: "5px 10px", cursor: "pointer" }}
              >
                Delete
              </button>
            </div>
            {selectedLog && selectedLog._id === log._id && (
              <div className="log-details">
                <p><strong>Subject:</strong> {selectedLog.subject}</p>
                <p><strong>Text:</strong> {selectedLog.text}</p>
                <p><strong>Image Path:</strong> {selectedLog.imagePath}</p>
                <p><strong>CSV File:</strong> {selectedLog.csvFileName}</p>
                <p><strong>Date:</strong> {new Date(selectedLog.date).toLocaleString()}</p>
                <p><strong>Success:</strong> {selectedLog.successCount}</p>
                <p><strong>Failure:</strong> {selectedLog.failureCount}</p>
                <h3>Recipients:</h3>
                <ul>
                  {selectedLog.recipients && selectedLog.recipients.map(recipient => (
                    <li key={recipient.email}>
                      {recipient.name || "No name"} ({recipient.email}) - {recipient.status}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default LogsPage;
